import React, {useState, useEffect} from 'react'
import Status from '../../Components/Status/Status'
import { Oval } from 'react-loader-spinner'
import { useQuery } from 'react-query'
import { baseUrl, path } from '../../constants'
import axios from 'axios'
import dayjs from 'dayjs'
import { api } from '../../api'
import { toast } from 'react-toastify'

export default function Users({sellers}) {
    const states = ['pending', 'activeInst', 'activeInd', 'rejected']
    const [tab, setTab] = useState(0)
    const { isLoading, error, data, refetch } = useQuery('fetchUsers', () =>
        axios(baseUrl + path.users + `?type=${sellers ? `seller&filter=${states[tab]}` : 'user'}`, {
        })
    )
    const [users, setUsers] = useState([])
    const [user, setUser] = useState(null)

    useEffect(() => {
        if(data) setUsers(data.data?.users || [])
    }, [data])

    useEffect(() => {
        refetch()
    }, [tab, sellers])

    const [loading, setLoading] = useState(null)

    const upgradeSeller = (id) => {
        setLoading(id)
        api.post(path.upgradeSeller, {
            id
        }).then(response => {
            let data = response.data
            if(data.success){
                setUsers(u => u.map(user => {
                    if(user.id == id) return {...user, isInstitute: data.mode}
                    return user
                }))
            }
        }).finally(() => setLoading(false))
    }

    return [
        <h1>{sellers ? 'Sellers' : 'Users'}</h1>,
        isLoading ? (
            <div className='flex flex-col items-center gap-3'>
                <p className='text-black text-[15px]'>Loading data...</p>
                <Oval
                    visible={true}
                    height="30"
                    width="30"
                    color="#198754"
                    ariaLabel="oval-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                    strokeWidth={3}
                    />
            </div>
        ) : (
            <div className='w-full h-full flex flex-col bg-white rounded-sm p-4 gap-4 overflow-auto'>
            <div className='flex items-center justify-between'>
                <div className='flex gap-4 items-center'>
                    <div className='flex h-[40px] w-[300px] relative border-solid border-[#0000007f] border-[1px]'>
                        <input placeholder={'Search ' + sellers ? 'Sellers & Institutions' : 'Users'} className='h-full w-full pl-5' />
                    </div>
                </div>
                <button className='px-5 py-2 bg-main text-white text-[12px] font-bold outline-none border-none bg-none'>Export Data</button>
            </div>
            {sellers && (
                <div className='flex items-center gap-4'>
                    <button onClick={() => setTab(0)} className={`px-4 py-2 font-bold rounded-md ${tab == 0 ? 'text-white bg-main' : 'text-main bg-white border-[1px] border-main'}`}>
                        Pending Applications
                    </button>
                    <button onClick={() => setTab(1)} className={`px-4 py-2 font-bold rounded-md ${tab == 1 ? 'text-white bg-main' : 'text-main bg-white border-[1px] border-main'}`}>
                        Active Institutes
                    </button>
                    <button onClick={() => setTab(2)} className={`px-4 py-2 font-bold rounded-md ${tab == 2 ? 'text-white bg-main' : 'text-main bg-white border-[1px] border-main'}`}>
                        Active Individuals
                    </button>
                    <button onClick={() => setTab(3)} className={`px-4 py-2 font-bold rounded-md ${tab == 3 ? 'text-white bg-main' : 'text-main bg-white border-[1px] border-main'}`}>
                        Rejected Applications
                    </button>
                </div>
            )}
                <table className='w-full' cellPadding={10}>
                <thead>
                    <tr className='border-b-solid border-b-[1px] border-b-[#00000068] bg-[#ededed]'>
                        <th align='left' className='p-2 text-[14px]'>Name</th>
                        <th align='left' className='p-2 text-[14px]'>Contact</th>
                        <th align='left' className='p-2 text-[14px]'>User Type</th>
                        <th align='left' className='p-2 text-[14px]'>Registered Date</th>
                        <th align='left' className='p-2 text-[14px]'>Status</th>
                        <th align='left' className='p-2 text-[14px]'>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {(users || []).map(row => (
                        <tr className='border-b-solid border-b-[1px] border-b-[#00000068]'> 
                            <td className='text-[13px] p-2'>{row?.sellerprofile?.name || (row?.firstName + ' ' + row?.lastName )}</td>
                            <td className='text-[13px] p-2'>{row.phone || row?.representativePhone || row.email}</td>
                            <td className='text-[13px] p-2'><span className='bg-black px-2 py-1 text-white text-sm font-bold rounded-md'>{!row.userStatus ? 'Normal' : ['1', '2'].includes(row.userStatus) ? 'Individual Seller' : 'Institute'}</span></td>
                            <td className='text-[13px] p-2'>{dayjs(sellers ? row.sellerprofile?.createdAt : row.createdAt).format('MM/DD/YY HH:mm:ss')}</td>
                            <td className='text-[13px] p-2'>{sellers ? ['Pending', 'Active Individual', 'Pending', 'Active Institute', 'Rejected'][row.userStatus - 1] : row.active ? 'Active' : 'In-Active'}</td>
                            <td className='text-[13px] p-2 flex items-center gap-2'>
                                { sellers ? [
                                    // <button onClick={() => upgradeSeller(row.id)} className={'px-4 bg-main text-white py-1 text-sm font-bold rounded-md'}>
                                    //     {loading == row.id ? (
                                    //         <Oval
                                    //             visible={true}
                                    //             height="30"
                                    //             width="30"
                                    //             color="#ffffff"
                                    //             ariaLabel="oval-loading"
                                    //             wrapperStyle={{}}
                                    //             wrapperClass=""
                                    //             strokeWidth={3}
                                    //         />
                                    //     ) : row.isInstitute ?  'Mark as Seller' : 'Mark as Institution'}
                                    // </button>,
                                        <button className='text-white px-4 py-2 bg-main text-xs font-bold rounded-md' onClick={() => setUser(row)}>Show Information</button>,
                                    ] : '' }
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {user && <Information user={user} setUser={setUser} refetch={refetch} />}
        </div>
        )
    ]
}


function Information({ user, setUser, refetch }){
    const type = user?.userStatus == '1' ? 'Individual' : 'Institute'
    const indCells = [
        {label: 'Name', accessor: 'name'},
        {label: 'Area Expertise', accessor: 'areaExpertize'},
        {label: 'Biography', accessor: 'bio', long: true},
        {label: 'Qualification', accessor: 'qualification'},
        {label: 'Qualification Document', accessor: 'qualificationDoc', link: true},
        {label: 'Id Document', accessor: 'idDoc', link: true},
        {label: 'Current Occupation', accessor: 'occupation'},
        {label: 'Years of Experience', accessor: 'experience'},
        {label: 'How user find us', accessor: 'finding'},
    ]
    const instCells = [
        {label: 'Name', accessor: 'name'},
        {label: 'Biography', accessor: 'bio', long: true},
        {label: 'Institute Type', accessor: 'instituteType'},
        {label: 'Established Year', accessor: 'yearEstablished'},
        {label: 'Target Audience', accessor: 'targetAudience'},
        {label: 'Representative Name', accessor: 'representative'},
        {label: 'Representative Contact', accessor: 'representativePhone'},
        {label: 'Trade License', accessor: 'licenseDoc', link: true},
        {label: 'How Institute find us', accessor: 'finding'},
    ]
    let cells = ['1', '2'].includes(user?.userStatus) ? indCells : instCells
    const [isApproving, setIsApproving] = useState(false)
    const [isRejecting, setIsRejecting] = useState(false)

    const action = (type) => {
        type == 'approve' ? setIsApproving(true) : setIsRejecting(true)
        api.patch(path.sellerStatus, {
            id: user.id,
            action: type
        }).then(response => {
            let data = response.data
            if(data.success){
                toast.success('Success!', {hideProgressBar: true})
                refetch()
                setUser(null)
            }
        } )
        .finally(() =>  type == 'approve' ? setIsApproving(false) : setIsRejecting(false))
    }

    return (
        <div className='fixed inset-0 bg-[#00000070] flex items-center justify-center'>
            <div className='flex flex-col bg-white p-8 relative rounded-md gap-5'>
                <h1 className='self-center text-sm font-bold text-black'>{type} Information</h1>
                <table style={{
                    border: '1px sold #00000070',
                    borderCollapse: 'collapse',
                    borderRadius: '5px',
                    flex: 1
                }}>
                    <tbody>
                        {cells.map(cell => (
                             <tr style={{
                                padding: '10px',
                            }}>
                                <td className='p-2 text-sm font-bold' style={{border: '1px solid #00000070'}}>{cell.label}</td>
                                <td className='p-2 text-sm' style={{border: '1px solid #00000070', maxWidth: '300px'}}>{cell.link ? <a className='text-main font-bold underline' href={baseUrl + user?.sellerprofile[cell.accessor]} target='_blank'>Open Document</a> : user?.sellerprofile[cell.accessor]}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <div className='flex gap-4 items-center justify-center'>
                    {!['2', '4'].includes(user?.userStatus) && [
                        <button disabled={isApproving} className='text-white px-4 py-2 bg-[#008b00] text-xs font-bold rounded-md' onClick={() => action('approve')}>
                        {isApproving ? (
                            <Oval
                                visible={true}
                                height="17"
                                width="17"
                                color="#ffffff"
                                ariaLabel="oval-loading"
                                wrapperStyle={{}}
                                wrapperClass=""
                                strokeWidth={3}
                            />
                        ) :  'Approve'}
                        </button>,
                        <button disabled={isRejecting} className='text-white px-4 py-2 bg-[#ff0000] text-xs font-bold rounded-md' onClick={() => action('reject')}>
                            {isRejecting ? (
                                <Oval
                                    visible={true}
                                    height="17"
                                    width="17"
                                    color="#ffffff"
                                    ariaLabel="oval-loading"
                                    wrapperStyle={{}}
                                    wrapperClass=""
                                    strokeWidth={3}
                                />
                            ) :  'Reject'}
                        </button>
                    ]}
                    <button className='text-white px-4 py-2 bg-[#00000060] text-xs font-bold rounded-md' onClick={() => setUser(null)}>Cancel</button>
                </div>
            </div>
        </div>
    )
}